import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';
import SuggestionItem from './SuggestionItem/SuggestionItem.js';
import SuggestionTopContent from './SuggestionTopContent/SuggestionTopContent.js';

const Suggestions = (_param)=> {
    var { autocompleteName , className , cursor , suggestions , suggestionTopContent , noResults , onSuggestionTopContentClick , onSuggestionClick , setHovered , setFocus , onBlur  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "autocompleteName",
        "className",
        "cursor",
        "suggestions",
        "suggestionTopContent",
        "noResults",
        "onSuggestionTopContentClick",
        "onSuggestionClick",
        "setHovered",
        "setFocus",
        "onBlur"
    ]);
    return React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('autocomplete-suggestions', className)
    }), /*#__PURE__*/ React__default.createElement("ul", {
        id: `${autocompleteName}-suggestions`,
        role: "listbox",
        className: "autocomplete-suggestions__list"
    }, suggestionTopContent && /*#__PURE__*/ React__default.createElement(SuggestionTopContent, {
        suggestionTopContent: suggestionTopContent,
        cursor: cursor,
        onClick: onSuggestionTopContentClick,
        setHovered: setHovered,
        setFocus: setFocus
    }), suggestions.length > 0 ? suggestions.map((suggestion)=>/*#__PURE__*/ React__default.createElement(SuggestionItem, {
            onSuggestionClick: onSuggestionClick,
            suggestion: suggestion,
            key: suggestion.id,
            active: cursor === suggestion.cursor,
            setHovered: setHovered,
            setFocus: setFocus,
            onBlur: onBlur,
            "data-t": "autoCompleteSuggestion"
        })
    ) : /*#__PURE__*/ React__default.createElement("div", {
        className: "autocomplete-suggestions__no-result"
    }, noResults)));
};
var Suggestions$1 = Suggestions;

export { Suggestions$1 as default };
//# sourceMappingURL=Suggestions.js.map
